import { AuthUser } from 'app/provider/auth'
import { LogInOutput } from '../commands'

export class LogInOutputToAuthUserConverter {
  static convert(data: LogInOutput): AuthUser {
    return {
      token: data.login.token,
      fullName: data.login.user.fullName,
      email: data.login.user.email,
      id: data.login.user.id,
      userType: data.login.user.userType,
      completedMarketing: data.login.user.completedMarketing,
      ucasNumber: data.login.user.ucasNumber,
      universityEmail: data.login.user.universityEmail,
      subjectOfStudy: data.login.user.subjectOfStudy,
      university: data.login.user.university,
      yearOfStudy: data.login.user.yearOfStudy+'',
      avatar: {
        small: data.login.user.avatar?.sizes?.small?.url || '',
        medium: data.login.user.avatar?.sizes?.medium?.url || '',
      },
      universityEmailVerified: data.login.user.universityEmailVerified,
      createdAt: new Date(data.login.user.createdAt),
      allowMarketing: data.login.user.allowMarketing,
      referralUrl: data.login.user.referralUrl,
    }
  }
}
